import React from 'react';
import { X } from 'lucide-react';
import RegistroProveedor from '../../../components/RegistroProveedor';

export default function RegistroEmpresaModal({ onClose, searchOverride = null }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm overflow-y-auto flex items-start justify-center p-4">
      <div className="relative w-full max-w-2xl my-4 rounded-3xl overflow-hidden shadow-2xl border border-white/10">

        {/* Header oscuro */}
        <div className="flex items-center justify-between bg-gradient-to-r from-slate-950 to-emerald-950 border-b border-white/10 px-6 py-4">
          <div>
            <p className="text-[11px] font-black uppercase tracking-widest text-emerald-400">KawésCar</p>
            <h2 className="text-lg font-black text-white">Registrar Empresa</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-xl border border-white/20 text-white/60 hover:bg-white/10 hover:text-white transition"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="bg-white">
          <RegistroProveedor isModal={true} onClose={onClose} searchOverride={searchOverride} />
        </div>
      </div>
    </div>
  );
}
